// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-mallit-js": () => import("./../../../src/pages/mallit.js" /* webpackChunkName: "component---src-pages-mallit-js" */),
  "component---src-templates-model-page-js": () => import("./../../../src/templates/model-page.js" /* webpackChunkName: "component---src-templates-model-page-js" */),
  "component---src-templates-page-js": () => import("./../../../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */)
}

